import { createCacheAsync } from "@repo/shared-utils/cache";
import { request } from "../core/request";
import { OPERATION_IDS, REST_CONNECTION_FROM } from "./constants";
import type { ISolarReadPayload, ISolarReadResponse } from "../types/solarReadTypes";

export const solarRead = async (reqData: ISolarReadPayload): Promise<ISolarReadResponse> => {
  try {
    const response = (await createCacheAsync(
      `${OPERATION_IDS.solarRead}-${reqData.mobileNo}-${reqData.id}`,
      async () =>
        await request<ISolarReadResponse, ISolarReadPayload>({
          operationId: OPERATION_IDS.solarRead,
          requestData: reqData,
          connectionFrom: REST_CONNECTION_FROM,
        })
    )) as ISolarReadResponse;

    return response;
  } catch (error) {
    console.error("Error in solarRead", error);

    return {
      solarLoanDetailsList: null,
      description: "Error fetching solar read data",
      statusCode: "7002",
    };
  }
};
